enum BrowserSupportFeatureEnum {
    // @ts-ignore
    webp = "webp",
}

export default BrowserSupportFeatureEnum;